import { render, staticRenderFns } from "./Regularize.vue?vue&type=template&id=2fc8b9e0&scoped=true"
import script from "./Regularize.vue?vue&type=script&lang=js"
export * from "./Regularize.vue?vue&type=script&lang=js"
import style0 from "./Regularize.vue?vue&type=style&index=0&id=2fc8b9e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc8b9e0",
  null
  
)

export default component.exports